import { PublicProfileStatusEnum, PublicProfileTypeEnum } from '@onArte/shared/database/enums';
import { SimpleElementInterface } from '@onArte/shared/interfaces';
import { ExternalAttachmentInterface, UploadedAttachmentInterface } from '@onArte/shared/interfaces/common';
import { SimpleBlogPostInterface } from '@onArte/shared/interfaces/common/blog';
import { PublicProfileVersionModel } from '@onArte/shared/models/common/publicProfiles';
import { WebsiteUrlModel } from '@onArte/shared/models/management/website';

export class PublicProfileManagementModel {
  public id: string;
  public type: PublicProfileTypeEnum;
  public status: PublicProfileStatusEnum;
  public name: string;
  public relation: SimpleElementInterface<string>;
  public url: WebsiteUrlModel | null;
  public description: string;
  public bio: string;
  public attachments: (ExternalAttachmentInterface | UploadedAttachmentInterface)[];
  public versions: PublicProfileVersionModel[];
  public blogPosts: SimpleBlogPostInterface[];
}
